import { LicensesCardModel } from './licenses-card.model';

export class LicensesListModel {
  class: string;
  dataJson: LicensesCardModel[];
  offset: number;
  totalLength: number;

  constructor() {
    this.class = undefined;
    this.dataJson = undefined;
    this.offset = undefined;
    this.totalLength = undefined;
  }
}
